module.exports = __webpack_public_path__ + "static/video-68638f46a97200813a9c6d9971152a12.mp4";